import { Pipe, PipeTransform } from '@angular/core';
import { CoreoService } from '../core/services';

@Pipe({
    name: 'barrierPhoto'
})
export class BarrierPhotoPipe implements PipeTransform {
    constructor(private coreo: CoreoService) { }

    transform(id: number) {
        return this.coreo.photoUrl(id, 'photo', undefined, 300);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/barrier-photo.pipe.ts